<template>
    <section class="about-video content-section container px-3">
        <h2 class="content-section-title">{{info.title}}</h2>
        <VideoPlayer :videos="info.videos" />
    </section>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'

export default {
    components: {VideoPlayer},
    props: ['info'],
}
</script>
